export const CURRENCY_CONFIG = {
  XOF: { symbol: "FCFA", rate: 1, decimals: 0, position: "suffix", label: "Franc CFA" },
  EUR: { symbol: "€", rate: 0.001525, decimals: 2, position: "suffix", label: "Euro" },
  USD: { symbol: "$", rate: 0.00164, decimals: 2, position: "prefix", label: "Dollar US" },
};

export function convert(amountXof, currency = "XOF") {
  const config = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.XOF;
  return (Number(amountXof) || 0) * config.rate;
}

export function formatPrice(amountXof, currency = "XOF") {
  const config = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG.XOF;
  const value = convert(amountXof, currency);
  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: config.decimals,
    maximumFractionDigits: config.decimals,
  }).format(value);
  return config.position === "prefix" ? `${config.symbol}${formatted}` : `${formatted} ${config.symbol}`;
}

export function formatDate(value) {
  if (!value) return "—";
  try {
    return new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "short", year: "numeric" }).format(
      new Date(value),
    );
  } catch (e) {
    return "—";
  }
}

export function formatDateTime(value) {
  if (!value) return "—";
  try {
    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value));
  } catch (e) {
    return "—";
  }
}

export const PAYMENT_LABELS = {
  visa: "Visa",
  mastercard: "Mastercard",
  paypal: "PayPal",
  orange_money: "Orange Money",
  mtn_money: "MTN Mobile Money",
  wave: "Wave",
  manual: "Paiement à la confirmation",
};

export const PAYMENT_STATUS = {
  paid: { label: "Payé", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pending: { label: "En attente", className: "bg-amber-50 text-amber-700 border-amber-200" },
  refunded: { label: "Remboursé", className: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const ORDER_STATUS = {
  pending: { label: "En attente de paiement", className: "bg-amber-50 text-amber-700 border-amber-200" },
  payment_review: { label: "Paiement à vérifier", className: "bg-orange-50 text-orange-700 border-orange-200" },
  payment_rejected: { label: "Paiement rejeté", className: "bg-rose-50 text-rose-700 border-rose-200" },
  processing: { label: "En traitement", className: "bg-amber-50 text-amber-700 border-amber-200" },
  preparing: { label: "En préparation", className: "bg-sky-50 text-sky-700 border-sky-200" },
  shipped: { label: "Expédiée", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  delivered: { label: "Livrée", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  completed: { label: "Terminée", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "Annulée", className: "bg-rose-50 text-rose-700 border-rose-200" },
  refunded: { label: "Remboursée", className: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const ORDER_STATUS_OPTIONS = ["pending", "payment_review", "payment_rejected", "processing", "preparing", "shipped", "delivered", "cancelled", "refunded"];

export const LICENSE_STATUS = {
  available: { label: "Disponible", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  reserved: { label: "Réservée", className: "bg-amber-50 text-amber-700 border-amber-200" },
  sold: { label: "Vendue", className: "bg-brand-light text-brand border-brand/20" },
  cancelled: { label: "Annulée", className: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const stripMd = (s = "") =>
  String(s)
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/__(.*?)__/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/(^|\n)#{1,6}\s+/g, "$1")
    .replace(/(^|\n)\s*[*-]\s+/g, "$1• ");
